var map = {
	"./baguette-cut.svg": 29011,
	"./cushion-cut.svg": 88277,
	"./emerald-cut.svg": 86324,
	"./heart-cut.svg": 92864,
	"./marquise-cut.svg": 24869,
	"./oval-cut.svg": 76418,
	"./pear-cut.svg": 9734,
	"./princess-cut.svg": 16899,
	"./round-cut.svg": 48360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23660;